export default __webpack_public_path__ + "static/media/loading.5f791ea6.svg";